import { Fragment, useCallback, useMemo, useState } from "react";

import { EmbedDialog } from "@/components/popups/EmbedDialog";
import { PopOverMenu } from "@/components/popups/PopOverMenu";
import { getShareMenuItems } from "./data";
import "./ShareMenu.scss";
import { metricsBus } from "@/common/buses";

interface IShareMenuProps {
  anchorEl: HTMLElement | null;
  onClick: (label: string) => void;
  onClose: () => void;
  fixedEmbedCode: string;
  responsiveEmbedCode: string;
  isGifPublished?: boolean;
  userIsAuthenticated?: boolean;
}

export const ShareMenu = (props: IShareMenuProps) => {
  const {
    anchorEl,
    onClick,
    onClose,
    fixedEmbedCode,
    responsiveEmbedCode,
    isGifPublished = true,
    userIsAuthenticated = false,
  } = props;

  const [shareOpen, setShareOpen] = useState<boolean>(true);
  const [embedOpen, setEmbedOpen] = useState<boolean>(false);

  const handleEmbedOpen = useCallback(() => {
    setEmbedOpen(true);
    setShareOpen(false);
  }, []);

  const handleClick = useCallback((label: string) => {
    if (label === "Embed") {
      handleEmbedOpen();
      metricsBus.emit("shareEmbed");
      return;
    }

    onClick(label);
  }, [handleEmbedOpen, onClick]);

  const menuItems = useMemo(() => {
    return getShareMenuItems(handleClick, isGifPublished, userIsAuthenticated);
  }, [handleClick]);

  return (
    <Fragment>
      {
        shareOpen && <PopOverMenu
          className="ShareMenu"
          title="Share"
          anchorEl={anchorEl}
          isOpen={true}
          onClose={onClose}
          menuItems={menuItems}
        />
      }

      <EmbedDialog
        isOpen={embedOpen}
        onClose={onClose}
        fixedEmbedCode={fixedEmbedCode}
        responsiveEmbedCode={responsiveEmbedCode}
      />
    </Fragment>
  );
};
